<template>
  <v-dialog
    v-model="isOpen"
    max-width="1280"
    content-class="report-modal-dialog"
  >
    <Report
      v-if="reportId"
      :id="reportId"
      :key="reportKey"
      :initialFilters="filters"
      :customTitle="title"
      :hidden-fields="hiddenFields"
      class="report-modal-content"
      :class="{ 'has-history': hasHistory }"
      @navigateReport="onNavigateReport"
      @closeModal="close"
    />
    <v-btn
      v-if="hasHistory"
      class="report-modal-back"
      fab
      icon
      small
      @click="goBack"
    >
      <v-icon color="light">chevron_left</v-icon>
    </v-btn>
    <v-btn
      v-if="!isMobile"
      class="report-modal-open-tab"
      fab
      icon
      small
      @click="openInNewTab"
    >
      <v-icon color="light">mdi-open-in-new</v-icon>
    </v-btn>
    <v-btn class="report-modal-close" fab icon small @click="close">
      <v-icon color="light">mdi-close</v-icon>
    </v-btn>
  </v-dialog>
</template>

<script>
import EventBus from '@/factories/eventBus';
import Report from './Report.vue';

export default {
  name: 'ReportModal',
  components: {
    Report,
  },
  data() {
    return {
      isOpen: false,
      reportId: '',
      filters: {},
      title: '',
      hiddenFields: [],
      reportKey: 0,
      history: [],
    };
  },
  computed: {
    hasHistory() {
      return this.history.length > 0;
    },
  },
  methods: {
    open({ reportId, filters = {}, title = '', hiddenFields = [] }) {
      this.history = [];
      this.reportId = reportId;
      this.filters = filters;
      this.title = title;
      this.hiddenFields = hiddenFields;
      this.reportKey++;
      this.isOpen = true;
    },

    close() {
      this.isOpen = false;
      this.reportId = '';
      this.filters = {};
      this.title = '';
      this.hiddenFields = [];
      this.history = [];
    },

    onNavigateReport({ reportId, filters }) {
      // Save current state to history before navigating
      this.history.push({
        reportId: this.reportId,
        filters: { ...this.filters },
        title: this.title,
        hiddenFields: [...this.hiddenFields],
      });

      this.reportId = reportId;
      this.filters = filters;
      this.title = '';
      this.hiddenFields = [];
      this.reportKey++;
    },

    goBack() {
      if (!this.hasHistory) return;

      const previous = this.history.pop();
      this.reportId = previous.reportId;
      this.filters = previous.filters;
      this.title = previous.title;
      this.hiddenFields = previous.hiddenFields;
      this.reportKey++;
    },

    openInNewTab() {
      const route = this.$router.resolve({
        name: 'report',
        params: { id: this.reportId },
        query: this.filters,
      });
      window.open(route.href, '_blank');
    },
  },
  mounted() {
    EventBus.$on('openReportModal', this.open);
  },
  beforeDestroy() {
    EventBus.$off('openReportModal', this.open);
  },
};
</script>

<style lang="less">
.report-modal-dialog {
  height: 80vh;
  overflow: hidden;
  position: relative;
}

.v-btn.report-modal-back {
  position: absolute !important;
  top: 10px;
  left: 10px;
  z-index: 10;
}

.v-btn.report-modal-open-tab {
  position: absolute !important;
  top: 10px;
  right: 46px;
  z-index: 10;
}

.v-btn.report-modal-close {
  position: absolute !important;
  top: 10px;
  right: 10px;
  z-index: 10;
}

.report-modal-content {
  height: 100%;
  overflow: hidden;
  padding-top: 0;
  background-color: var(--v-light-base);

  // Override page-layout styles for modal context
  &.page-layout {
    padding: 0;
    overflow: hidden;

    &.has-header {
      padding-top: 0;
    }
  }

  // Make header relative instead of fixed
  .app-header {
    position: relative;
    width: 100%;
    left: 0;
    padding-left: 12px;
    padding-right: 42px;

    @media (min-width: 960px) {
      padding-right: 80px;
    }
  }

  // Add padding for back button when history exists
  &.has-history .app-header {
    padding-left: 48px;
  }

  .page-layout__content {
    height: calc(100% - 56px) !important;
  }

  // Hide default back button - we use our own
  .app-header__toggle--btn,
  .button-back {
    display: none !important;
  }

  .content-main {
    margin-left: 0;
    max-width: 100%;
    background-color: var(--v-background-base);
  }
}
</style>
